import Vue from 'vue';
import VueRouter from 'vue-router';
import index from '../views/Index.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'index',
		component: index,
	},
	{
		path: '/servicios',
		name: 'servicios',
		component: () => import(/* webpackChunkName: "servicios" */ '../views/Servicios.vue'),
	},
	{
		path: '/nosotros',
		name: 'nosotros',
		component: () => import(/* webpackChunkName: "nosotros" */ '../views/Nosotros.vue'),
	},
	{
		path: '/sectores',
		name: 'sectores',
		component: () => import(/* webpackChunkName: "sectores" */ '../views/Sectores.vue'),
	},
	{
		path: '/contacto',
		name: 'Contacto',
		component: () => import(/* webpackChunkName: "contacto" */ '../views/Contacto.vue'),
	},
	{
		path: '/coockies',
		name: 'Coockies',
		component: () => import(/* webpackChunkName: "coockies" */ '../views/Coockies.vue'),
	},
	{
		path: '/Politica',
		name: 'Politica',
		component: () => import(/* webpackChunkName: "politica" */ '../views/Politica.vue'),
	},
	{
		path: '/legal',
		name: 'Legal',
		component: () => import(/* webpackChunkName: "legal" */ '../views/Legal.vue'),
	},
];

const router = new VueRouter({
	linkActiveClass: 'active',
	routes,
});

export default router;
